import { apiClient } from '../utils/api';
import type { ActPhoto, ActPhotoType } from '../components/camera/types';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export async function listActPhotos(actId: string): Promise<ActPhoto[]> {
  const response = await apiClient(`/api/acts/${actId}/photos`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to fetch act photos');
  }
  const data: ApiResponse<{ photos: ActPhoto[] }> = await response.json();
  return data.data?.photos ?? [];
}

export async function uploadActPhoto(
  actId: string,
  blob: Blob,
  type: ActPhotoType,
): Promise<ActPhoto> {
  const formData = new FormData();
  formData.append('photo', blob, `capture_${Date.now()}.jpg`);
  formData.append('photoType', type);

  const response = await apiClient(`/api/acts/${actId}/photos`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to upload act photo');
  }

  const data: ApiResponse<{ photo: ActPhoto }> = await response.json();
  if (!data.success || !data.data?.photo) {
    throw new Error(data.message || 'Failed to upload act photo');
  }
  return data.data.photo;
}

export async function deleteActPhoto(actId: string, photoId: string): Promise<void> {
  const response = await apiClient(`/api/acts/${actId}/photos/${photoId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to delete act photo');
  }
}
